var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.19922 4V8.5C9.19922 9.32843 9.87079 10 10.6992 10H15.1992V18.5C15.1992 19.3284 14.5276 20 13.6992 20H4.69922C3.87079 20 3.19922 19.3284 3.19922 18.5V5.5C3.19922 4.67157 3.87079 4 4.69922 4H9.19922ZM10.1992 4.25V8.5C10.1992 8.77614 10.4231 9 10.6992 9H14.9492L10.1992 4.25Z",
    fill: "#342C82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsFilled);
export default __webpack_public_path__ + "static/media/ProjectsFilled.5f382cc29c016cad2bc5dade3ee41a3c.svg";
export { ForwardRef as ReactComponent };